var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.91747C18.0771 2.91747 23 7.63263 23 13.4532C23 19.2841 18.0779 24 12 24C5.92292 24 1 19.2848 1 13.4642C1 11.3017 1.68547 9.28402 2.8519 7.60822C3.16882 7.1529 3.8111 7.02987 4.28647 7.33341C4.76184 7.63695 4.8903 8.25212 4.57338 8.70744C3.62487 10.0702 3.06896 11.7076 3.06896 13.4642C3.06896 18.1904 7.06558 22.0184 12 22.0184C16.9336 22.0184 20.931 18.1912 20.931 13.4532C20.931 8.72706 16.9344 4.89912 12 4.89912C10.8946 4.89912 9.89121 5.06859 8.97437 5.33102C7.40496 5.78025 6.99419 5.80007 6.5 5.45455C6.00581 5.10902 6.08083 4.50362 6.41768 4.06163L9.79426 0.340291C10.1694 -0.0724545 10.8228 -0.115791 11.2537 0.243497C11.6847 0.602784 11.7299 1.22864 11.3548 1.64139L10.0618 3.06408C10.6753 2.97074 11.321 2.91747 12 2.91747Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H13.0689C13.0274 11 12.9902 11.0256 12.9755 11.0644L12.2039 13.0914C12.179 13.1568 12.2272 13.227 12.2973 13.227C12.8611 13.227 13.5807 13.227 14.5 13.227C15.5 13.227 16.0139 13.8706 16 14.6364C15.9863 15.3894 15.5 16 14.5 16C13.5 16 12 16 12 16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16V11.2261C9.5 11.1392 9.39697 11.0937 9.33273 11.1521L8 12.3636",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBack);
export default __webpack_public_path__ + "static/media/move-back.68b55a3d5df790c4245aff42adeb640f.svg";
export { ForwardRef as ReactComponent };